import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { Icon, Typography } from '../../shared';
import { Button } from '../../shared/button';
import { modalDefaultStyles, Popup, PopupProps } from '../../shared/popup';

interface Props extends PopupProps {
    onClosePress: () => void;
}

export const PartRequestsConfirmClosePopup: FC<Props> = ({ onClosePress, ...props }) => {
    const { t } = useTranslation();

    return (
        <Popup {...props}>
            <View style={modalDefaultStyles.webHeader}>
                <Typography variant="h5">
                    {t('qmr:popups.partRequests.confirmClose.title', 'Close Part Collection Request')}
                </Typography>
            </View>

            <View style={modalDefaultStyles.webContent}>
                <Icon name="warning" color="graySix" size={22} style={modalDefaultStyles.webContentIcon} />
                <View>
                    <Typography variant="h5">
                        {t(
                            'qmr:popups.partRequests.confirmClose.message',
                            'Are you sure you want to close this part collection request?'
                        )}
                    </Typography>
                    <Typography variant="h5">
                        {t(
                            'qmr:popups.partRequests.confirmClose.disclaimer',
                            'Closed requests become archived and cannot be reopened.'
                        )}
                    </Typography>
                </View>
            </View>

            <View style={modalDefaultStyles.webFooter}>
                <Button
                    style={modalDefaultStyles.webCancelButton}
                    variant="ghost-blue"
                    title={t('qmr:popups.partRequests.confirmClose.cancel', 'Cancel')}
                    onPress={props.onModalHide}
                />
                <Button
                    title={t('qmr:popups.partRequests.confirmClose.close', 'Close Request')}
                    onPress={onClosePress}
                />
            </View>
        </Popup>
    );
};
